export default {
  HOME: "Башкы бет",
  BUY_NOW: "Азыр сатып алуу",
  PLAY: "Ойноо",
  Note: "Эскертме",
  WELCOME: "Кош келиңиз ",
  PICK_NUMBERS: "Сандарды тандоо",
  PROCEED_CART: "Себетке",
  PROCEED_CHECKOUT: "Тариздөө",
  CART_TOTAL: "Жалпы",
  BET_TOTAL: "Коюмдун суммасы",
  LINE: "Линия",
  PLACE_BET: "Коюм коюу",
  PRINT: "Басып чыгаруу",
  STAKE: "Коюм",
  LINES: "Линиялар",
  ADD_TO_CART: "Себетке кошуу",
  UPDATE_CART: "Себетти жаңыртуу",
  SUMMARY: "Жыйынтык",
  BACK: "Артка",
  RANDOMIZE_ALL: "Кокусунан тандоо",
  CLEAR_ALL: "Баарын тазалоо",
  ADD_LINE: "Линия кошуу",
  LINE_NO: "Линия №",
  MY_SHOPPING_CART: "Менин себетим",
  PENCIL: "Өзгөртүү",
  CHECKOUT_MSG_1: "«Төлөө» баскычын басуу менен сиз биздин ",
  CHECKOUT_MSG_2: "Эрежелер жана шарттар",
  CHECKOUT_MSG_3: "Бардык транзакциялар USD менен жүргүзүлөт. Башка валюталардагы баалар маалымат үчүн гана.",
  DELETE: "Жок кылуу",
  PRICE: "Баасы",
  PAY: "Төлөө",
  CHECKOUT: "Тариздөө",
  MY_WALLET: "Менин капчыгым",
  WALLET: "Капчык",
  LOTTO: "Лото",
  GAMES: "Оюндар",
  AMOUNT: "Сумма",
  TRANSACTIONS: "Транзакциялар",
  ID: "ID",
  ID_TRANSACTION: "Транзакциянын ID",
  DATE: "Дата",
  TYPE: "Түрү",
  STATUS: "Абалы",
  CREDIT: "Кредит",
  EDIT: "Өзгөртүү",
  FIELD_REQUIRED: "Бул талааны толтуруу керек",
  ERROR: "Ката",
  SUBMIT: "Жөнөтүү",
  LOTTO_GAMES: "Лото оюндары",
  BET_SLIP: "Коюм тилкеси",
  LOTTO_RESULTS: "Лото жыйынтыктары",
  INSUFFICIENT_FUNDS: "Каражат жетишсиз",
  INSUFFICIENT_FUNDS_MSG: "Сатып алууну аяктоо үчүн эсепти толтуруңуз.",
  CANCELED: "Жокко чыгарылды",
  PENDING: "Иштетилүүдө",
  WITHDRAW: "Чыгаруу",
  MY_TICKETS: "Менин билеттерим",
  DRAW_DATE: "Тартуу күнү",
  BET_ID: "Коюмдун ID",
  COST: "Наркы",
  WINNINGS: "Утуш",
  NEXT: "Кийинки",
  TICKET: "Билет",
  TICKETS: "Билеттер",
  TICKET_NUMBERS: "Билеттин сандары",
  LOGIN: "Кирүү",
  LOGIN_ALT: "Кирүү",
  LOGOUT: "Чыгуу",
  NO_ITEMS_IN_CART: "Себетиңиз бош",
  PROFILE: "Профиль",
  BET_PLACED_MSG: "Заказыңыз кабыл алынды!",
  PLAY_AGAIN: "Кайра ойноо!",
  ORDER: "Заказ",
  ORDER_CONFIRMATION: "Заказды тастыктоо",
  NOT_ENOUGH_BALANCE: "Балансыңызда каражат жетишсиз",
  NUMBERS_NOT_SELECTED_MSG: "Сиз сандарды тандаган жоксуз. Тандоо үчүн бул жерди басыңыз.",
  ENTER_A_NUMBER: "Санды киргизиңиз",
  LOADING: "Жүктөлүүдө...",
  TOTAL_COST: "Жалпы наркы",
  TOTAL: "Жалпы",
  PLACED: "Кабыл алынды",
  LOST: "Утулду",
  WON: "Утту",
  GROSS_WINNINGS: "Жалпы утуш",
  OK: "Ок",
  DEBIT: "Дебет",
  LOTTO_TICKET: "Лото билети",
  REFUND: "Кайтарым",
  WINNING: "Утуш",
  SUCCESSFUL: "Ийгиликтүү",
  FAILED: "Ката",
  PLAY_NOW: "Азыр ойноо!",
  DRAW_EVERY_5_MIN: "Ар 5 мүнүттө тартуу",
  COMING_SOON: "Жакында",
  LATEST_LOTTO_RESULTS: "Акыркы натыйжалар",
  SELECT_DRAW_DATE: "Тартуу күнүн тандоо",
  WINNING_NUMBERS: "Утуштуу сандар",
  MIN: "Мин",
  SEC: "Сек",
  MINUTES: "Мүнүттөр",
  SECONDS: "Секунддар",
  LATEST_LOTTERY_RESULTS: "Акыркы лотерея натыйжалары",
  DRAW_EVERY_5_MINS: "Ар 5 мүнүттө тартуу",
  SELECT_LOTTERY: "Лото тандоо",
  ALL_RESULTS: "Бардык натыйжалар",
  DRAW_NUMBER: "Тартуу номери",
  PERSONAL_DATA: "Жеке маалымат",
  NUMBER_OF_DRAWS: "Тартуулардын саны",
  QUICK_PICK: "Тез тандоо",
  CLEAR: "Тазалоо",
  FIELD: "Талаа",
  SUBMIT_TICKET: "Билетти жиберүү",
  ADD_ANOTHER_LINE: "Линия кошуу",
  DRAW_CLOSES_IN: "Тартуу жабылат",
  NO_DRAWS_FOUND: "Тартуулар табылган жок.",
  MY_BETS: "Менин коюмдарым",
  MY_BETS_LOTTO: "Менин лото коюмдарым",
  GAME: "Оюн",
  PLACED_DATE: "Коюлган күн",
  RESULT: "Натыйжа",
  MY_NUMBERS: "Менин сандарым",
  DRAW: "Тартуу",
  PERIOD: "Мезгил",
  QUICK_PICKS: "Тез тандоолор",
  SELECT_STAKE: "Коюмду тандоо",
  DRAWS_TEXT: "Тартуулар",
  NO_DATA_FOUND: "Маалымат табылган жок",
  PASSWORD: "Сырсөз",
  EMAIL: "Email",
  FIRST_NAME: "Аты",
  LAST_NAME: "Фамилиясы",
  MOBILE_NUMBER: "Телефон номери",
  REGISTER: "Катталуу",
  CREATE_ACCOUNT: "Аккаунт түзүү",
  FORGOT_PASSWORD: "Сырсөздү унуттуңузбу?",
  SIGN_IN: "Кирүү",
  SIGN_UP: "Катталуу",
  CONTINUE: "Улантуу",
  ALREADY_REGISTERED: "Аккаунтуңуз барбы?",
  LOGIN_HERE: "Бул жерден кириңиз.",
  SEND_OTP: "Код жөнөтүү",
  VERIFY_OTP: "Кодду тастыктоо",
  ENTER_CODE: "Кодду киргизиңиз",
  VERIFY: "Тастыктоо",
  RESET_PASSWORD: "Сырсөздү калыбына келтирүү",
  SET_PASSWORD: "Сырсөздү коюу",
  CONFIRM_PASSWORD: "Сырсөздү тастыктоо",
  COPY: "Көчүрүү",
  DONE: "Даяр",
  DEPOSIT: "Толтуруу",
  DEPOSIT_NOW: "Азыр толтуруу",
  DEPOSIT_AMOUNT: "Толтуруу суммасы",
  PROMOTIONS: "Акциялар",
  HOW_TO_PLAY: "Кантип ойноо керек",
  PROCESSING_PAYMENT: "Төлөм иштетилүүдө",
  PRIVACY_POLICY: "Купуялык саясаты",
  TERMS_CONDITION: "Шарттар жана эрежелер",
  DATA_NOT_AVAILABLE: "Маалымат жеткиликсиз.",
  SINGLE_LOTTERY_BET_AMOUNT: "Коюм суммасы",
  TOTAL_WINNINGS: "Жалпы утуш",
  TICKET_NUMBER: "Билет номери",
  SELLER: "Сатуучу",
  PURCHASE_DATE: "Сатып алуу күнү",
  ERROR_EMAIL_PASSWORD: "Ката: туура эмес email же сырсөз",
  PASSWORDS_DONT_MATCH: "Сырсөздөр дал келбейт",
  USER_NOT_FOUND: "Аккаунт табылган жок",
  ACCOUNT_ALREADY_EXISTS: "Аккаунт буга чейин бар",
};
